/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./selector-form-item.vue?vue&type=template&id=543ea49b&"
import script from "./selector-form-item.vue?vue&type=script&lang=js&"
export * from "./selector-form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports